import { render, staticRenderFns } from "./Messages.vue?vue&type=template&id=38f36384&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"
import style0 from "./Messages.vue?vue&type=style&index=0&id=38f36384&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f36384",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('38f36384')) {
      api.createRecord('38f36384', component.options)
    } else {
      api.reload('38f36384', component.options)
    }
    module.hot.accept("./Messages.vue?vue&type=template&id=38f36384&scoped=true", function () {
      api.rerender('38f36384', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Messages/Messages.vue"
export default component.exports